import { Identity } from '@sdbn/appclient';
import { Transport } from '../model/transport';
import { environment } from 'src/environments/environment';
import { HttpService } from '@sdbn/appclient';
import { DialogLayout } from 'src/app/shared/dialog-layout/dialog-layout';
import { TransportIssuesDialogComponent } from '../component/transport-issues-dialog.component';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { Injectable } from '@angular/core';
import { AsyncSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransportIssuesService {

  constructor(
    private dialog: MatDialog,
    private httpService: HttpService) { }

  public showTransportIssues(transportId: number): AsyncSubject<void> {

    const subject = new AsyncSubject<void>();

    const identity = new Identity();
    identity.id = transportId;

    this.httpService.postWithContext<Transport>(environment.transportIssuesEndpoint, identity).subscribe(
      transport => {
        this.dialog.open(TransportIssuesDialogComponent, {
          width: '900px',
          height: '700px',
          maxHeight: '95vh',
          data: transport,
          panelClass: DialogLayout.panelClass
        }).afterClosed().subscribe(
          result => {
            subject.next();
            subject.complete();
          }
        );
      }, error => {
        console.error('Error requesting transport details', error);
      }
    );

    return subject;
  }
}
